import { extractFileName } from 'src/helpers/integrations/filestack';
import { v4 as uuid4 } from 'uuid';

import type { UploadFile } from '../../useRepositoryDropzone';

export function createUploadItems(
  validFiles: File[],
  fileRefsMap: Map<string, File>
): UploadFile[] {
  return validFiles.map(file => {
    const id = uuid4();
    const filename = extractFileName(file.name);

    fileRefsMap.set(id, file);

    return {
      fileSize: file.size,
      filename,
      id,
      mimeType: file.type,
      progress: 0,
      state: 'pending',
    } satisfies UploadFile;
  });
}
